import { BinderSectionData } from '../hooks/useBinderSectionData';

const APPROVAL_METHODS: Record<string, string> = {
  email: 'Email',
  phone_call: 'Phone call',
};

const getMarketApprovalLines = (remark: Remark): string[] => {
  const customData = remark.custom_data;
  if (!customData || customData.type !== 'market_approval') return [];

  const dateAndTime = [customData.approval_date, customData.approval_time]
    .filter(Boolean)
    .join(' ');
  const summary = customData.summary_of_market_conversation_text?.trim();

  return [
    summary && `Summary of market conversation: ${summary}`,
    customData.market && `Market: ${customData.market}`,
    customData.underwriter_name &&
      `Underwriter: ${customData.underwriter_name}`,
    dateAndTime && `Approval date and time: ${dateAndTime}`,
    customData.approval_method &&
      `Approval method: ${
        APPROVAL_METHODS[customData.approval_method] ||
        customData.approval_method
      }`,
    customData.approval_number &&
      `Approval number: ${customData.approval_number}`,
  ].filter(Boolean) as string[];
};

interface ProcessedRemark {
  index: number;
  content: string;
  status: string;
  itemKey: string;
  section: number;
  validationKey: string | null;
}

export const processRemarksData = (
  remarks: Remark[] = [],
): BinderSectionData => {
  const processedRemarks: ProcessedRemark[] = [];

  remarks.forEach((remark, index: number) => {
    if (!remark) return;

    const content = [
      (remark.text || remark.ai_result || '').trim(),
      ...getMarketApprovalLines(remark),
    ]
      .filter(Boolean)
      .join('\n');

    if (content) {
      processedRemarks.push({
        index: index + 1,
        content,
        status: remark.status || 'unknown',
        itemKey: remark.item_key || 'unknown',
        section: remark.section,
        validationKey: remark.validation_key
          ? remark.validation_key.replace(/_/g, ' ').toLowerCase()
          : null,
      });
    }
  });

  return {
    title: 'Submission Remarks',
    description: 'All system and manual remarks for this policy.',
    isValid: true,
    message: null,
    data: {
      remarks: processedRemarks,
      totalRemarks: processedRemarks.length,
    },
  };
};
